import { createGlobalStyle } from 'styled-components'

/**
 * Scoped font loader for branded estimate report sections that use
 * Sequel Sans + Roboto Condensed Light.
 *
 * **Why createGlobalStyle?** `@font-face` rules are inherently global —
 * they cannot be class-scoped like normal CSS. createGlobalStyle injects
 * them into the document head when this component mounts, and removes
 * them when it unmounts.
 *
 * **Why not put it in index.html?** A `<link rel="stylesheet" href="...">`
 * in index.html means:
 *   1. The customer name leaks in the DOM and Network tab.
 *   2. All users download ~280KB of font files even if they never view a
 *      branded report.
 *
 * With this component, browsers only fetch the underlying TTF/OTF files
 * when text in those families actually renders. Non-branded users see
 * zero traffic to /fonts/sequel/.
 *
 * **Where to mount:** Render `<OmniaFontFaces />` inside any Omnia section
 * component. createGlobalStyle is idempotent — multiple instances inject
 * one shared set of rules into the document.
 */
export const OmniaFontFaces = createGlobalStyle`
  @font-face {
    font-family: 'Sequel Sans';
    src: url('/fonts/sequel/SequelSans-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Sequel Sans';
    src: url('/fonts/sequel/SequelSans-Roman.otf') format('opentype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Sequel Sans';
    src: url('/fonts/sequel/SequelSans-Book.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Roboto Condensed';
    src: url('/fonts/sequel/RobotoCondensed-Light.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
`
